import { useQuery } from '@tanstack/react-query';
import { getConfig, ConfigurationObject } from '../services/configs-api';

/**
 * TanStack Query hook for fetching a single configuration object by configId.
 * Optionally accepts configType to disambiguate items with the same name across types.
 */
export function useConfig(configId: string | undefined, configType?: string) {
  return useQuery<ConfigurationObject>({
    queryKey: ['configs', configId, configType],
    queryFn: () => getConfig(configId!, configType),
    enabled: !!configId,
  });
}
